import dotenv from 'dotenv';

dotenv.config();



// WEBPACK FOOTER //
// ./src/env.js